var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27093 1.92723C6.51821 1.5563 6.93452 1.3335 7.38033 1.3335H8.61984C9.06564 1.3335 9.48195 1.5563 9.72924 1.92723L10.3334 2.8335H12.8334C13.1096 2.8335 13.3334 3.05735 13.3334 3.3335C13.3334 3.60964 13.1096 3.8335 12.8334 3.8335H3.16675C2.89061 3.8335 2.66675 3.60964 2.66675 3.3335C2.66675 3.05735 2.89061 2.8335 3.16675 2.8335H5.66675L6.27093 1.92723ZM10.0001 14.6668H6.00008C4.52732 14.6668 3.33341 13.4729 3.33341 12.0002V4.66683H12.6667V12.0002C12.6667 13.4729 11.4728 14.6668 10.0001 14.6668ZM6.66675 6.8335C6.94289 6.8335 7.16675 7.05735 7.16675 7.3335V12.0002C7.16675 12.2763 6.94289 12.5002 6.66675 12.5002C6.39061 12.5002 6.16675 12.2763 6.16675 12.0002L6.16675 7.3335C6.16675 7.05735 6.39061 6.8335 6.66675 6.8335ZM9.33342 6.8335C9.60956 6.8335 9.83342 7.05735 9.83342 7.3335V12.0002C9.83342 12.2763 9.60956 12.5002 9.33342 12.5002C9.05727 12.5002 8.83342 12.2763 8.83342 12.0002V7.3335C8.83342 7.05735 9.05727 6.8335 9.33342 6.8335Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3976b6280730bb99cec9d29e44ff40f4.svg";
export { ForwardRef as ReactComponent };